(function() {
	'use strict';

	angular.module('quantixApp').controller('FooterController',
			FooterController);

	FooterController.$inject = [ '$scope', '$state', 'Auth', 'Principal','ProfileService', 'GenericServiceNew','AlertService','$uibModal' ];

	function FooterController($scope, $state, Auth, Principal, ProfileService, GenericServiceNew, AlertService,$uibModal) {
		var i=0;
		$scope.contactus=function(){
			if(i==0){
				$scope.theModal=$uibModal.open({
	                templateUrl: 'app/account/footer/contactus.html', controller:'contactcontroller', windowClass: 'large-Modal',})
	                i++;
	        	}
	        	$scope.theModal.result["catch"](function(){
	        		i=0;
	        	});
		}
	}
})();

